export const UPDATE_UM_PROP = 'UPDATE_UM_PROP';

export const ADD_USER_STARTING = 'ADD_USER_STARTING';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';
export const ADDED_USER = 'ADDED_USER';

export const UPDATE_USER_STARTING = 'UPDATE_USER_STARTING';
export const UPDATED_USER = 'UPDATED_USER';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const DELETE_USER_STARTING = 'DELETE_USER_STARTING';
export const DELETED_USER = 'DELETED_USER';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';

export const GETTING_USERS_BY_FILTER = 'GETTING_USERS_BY_FILTER';
export const GOT_USERS_BY_FILTER = 'GOT_USERS_BY_FILTER';
export const GETTING_USERS_BY_FILTER_FAILED = 'GETTING_USERS_BY_FILTER_FAILED';

export const GETTING_COMP_ADMIN = 'GETTING_COMP_ADMIN';
export const GOT_COMP_ADMIN = 'GOT_COMP_ADMIN';
export const GETTING_COMP_ADMIN_FAILED = 'GETTING_COMP_ADMIN_FAILED';

export const APPROVE_REJECT_USER_STARTED = 'APPROVE_REJECT_USER_STARTED';
export const APPROVE_REJECT_USER_DONE = 'APPROVE_REJECT_USER_DONE';
export const APPROVE_REJECT_USER_FAILED = 'APPROVE_REJECT_USER_FAILED';



// WEBPACK FOOTER //
// ./src/app/stores/settings/userManagement/constants.js